import React, { useEffect, useState } from 'react';
import './RaiseCatalog.css';
import { Link, useLocation } from 'react-router-dom';
import Loading from '../../../../../../../application/commons/loading/loading';
import BackButton from '../../../../../../../application/commons/back-button/back-button';
import { getCatagories, getCatalogItemsapi } from '../../../../utils/constants';
import { appConfig } from '../../../../../../../utils/app.config';
import { useSelector } from 'react-redux';

const RaiseCatalog: React.FC = () => {
    const location = useLocation();
    const { catalogData } = location.state || {};
    const [loading, setLoading] = useState(true);
    const [catalogs, setCatalogs] = useState([]);
    const [catalogItems, setCatalogItems] = useState([]);
    const [viewState, setViewState] = useState<'catalogs' | 'items' | 'none'>('none');

    const redirectUrl: string = useSelector((state: any) => state.headers.redirectUrl);

    useEffect(() => {
        if (catalogData?.child_categories?.length === 0) {
            getCatalogItems(catalogData.sys_id);
        } else {
            getTopCatalogList();
        }
    }, [catalogData]);

    const getTopCatalogList = async () => {
        setLoading(true);
        try {
            const options = { method: "GET", headers: { "Content-Type": "application/json" } };
            const result = await (await fetch(`${getCatagories}?sysId=${catalogData.sys_id}`, options)).json();

            if (result) {
                // If result is an array and it's empty
                if (Array.isArray(result) && result.length === 0) {
                    setViewState('none');
                }
                // If result is an object and child_categories is empty
                else if (result.child_categories?.length === 0) {
                    await getCatalogItems(result.sys_id);
                    setViewState('items');
                } else if (result.child_categories?.length > 0) {
                    setCatalogs(result.child_categories);
                    setViewState('catalogs');
                }
            } else {
                setViewState('none');
            }


        } catch (err) {
            console.log("ERROR :::", err);
            setViewState('none');
        } finally {
            setLoading(false);
        }
    };

    const getCatalogItems = async (sysid: string) => {
        setLoading(true);
        try {
            const options = { method: "GET", headers: { "Content-Type": "application/json" } };
            const result = await (await fetch(`${getCatalogItemsapi}?sysId=${sysid}`, options)).json();

            if (result) {
                setCatalogItems(result);
                setViewState('items');
            } else {
                setViewState('none');
            }
        } catch (err) {
            console.log("ERROR :::", err);
            setViewState('none');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <BackButton />
            <div className="raise_ticket">
                <div className="raise_image">
                    <div>
                        <div className="bot_logo"></div>
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div className="text1" style={{ marginBottom: "20px" }}>
                        <p>Raise a Catalog</p>
                    </div>
                    {loading ? (
                        <Loading />
                    ) : (
                        <>
                            {viewState === 'catalogs' && catalogs.length > 0 ? (
                                <ul className="catalog-main-list">
                                    {catalogs.map((catalog: any) => (
                                        <Link
                                            key={catalog.sys_id}
                                            to={`${redirectUrl}/desktop/raise-catalog`}
                                            state={{ catalogData: catalog }}
                                            style={{ textDecoration: 'none', color: 'black' }}
                                        >
                                            <li className="topCatalog-catalog">
                                                <img className="catalogIcon" src={appConfig.imagesUrl + "/desktop/Catalog.png"} />
                                                {catalog.title}
                                            </li>
                                        </Link>
                                    ))}
                                </ul>
                            ) : viewState === 'catalogs' ? (
                                <p style={{ margin: "10px", textAlign: "center" }}>No catalogs available</p>
                            ) : null}

                            {viewState === 'items' && catalogItems.length > 0 ? (
                                catalogItems.map((item: any) => (
                                    <div className="textbox1" key={item.sys_id}>
                                        <h5>{item.name}</h5>
                                        {item.description ? (
                                            <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                                        ) : (
                                            <p>{item.short_description}</p>
                                        )}

                                        {(item.icon || item.picture) && (
                                            <div className="catalog-item-image">
                                                <img
                                                    src={
                                                        item.picture
                                                            ? `https://dev188082.service-now.com/${item.picture}.iix`
                                                            : item.icon
                                                                ? `https://dev188082.service-now.com/${item.icon}.iix`
                                                                : ''
                                                    }
                                                    alt={item.name}
                                                    className="catalog-icon"
                                                />
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : viewState === 'items' ? (
                                <p style={{ margin: "10px", textAlign: "center" }}>No catalog items available</p>
                            ) : null}

                            {viewState === 'none' && <p style={{ margin: "10px", textAlign: "center" }}>No catalogs & catalog items available</p>}
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default RaiseCatalog;
